export default __webpack_public_path__ + "static/media/d2.dccaa631.png";